




















































































































































































import {Component, Inject, Vue} from 'vue-property-decorator';
import {ILink} from '@/setup/router/links';
import {IGlobalSettingsModel} from '@/modules/settings/global/IGlobalSettingsModel';
import ReconnectingWebSocket from 'reconnecting-websocket';
import {NotificationWS} from '@/modules/notifications/NotificationWSService';
import {version} from '@/constants';
import AuthServices from '@/modules/auth/AuthServices';

@Component({name: 'SideBar'})
export default class SideBar extends Vue {
  @Inject({from: Symbol.for('Links')}) links!: ILink[];
  @Inject({from: Symbol.for('GlobalConfigs')}) GlobalConfigs!: IGlobalSettingsModel;

  role: string = '';
  ws: ReconnectingWebSocket = <ReconnectingWebSocket> {};
  username: string = '';
  version: string = version;
  get drawer() {
    return this.$drawer.status;
  }
  set drawer(value){
    this.$drawer.status = value;
  }
  async created() {
    if (this.$route.matched[0] &&
        this.$route.matched[0].meta.modelName === 'requests' || this.$route.matched[0] &&
            this.$route.matched[0].name === 'distribution') {
      this.drawer = true;
    }

    this.role = JSON.parse(localStorage.getItem('group_type') || '[]')[0];
    this.username = JSON.parse(localStorage.getItem('loggedUser') || '{}').name.split('@')[0];
    const id = localStorage.getItem('tpv');
    this.ws = await NotificationWS('', id);
    this.ws.onmessage = data => {
      let notification = JSON.parse(data.data);
      this.$toast.info(notification.message, {dismissable: true, timeout: 9999});
    };
  }

// Methods
  async toLogin() {
    await AuthServices.logout({});
    localStorage.removeItem('token');
    localStorage.removeItem('modules');
    localStorage.removeItem('condominium');
    await this.$router.push({name: 'login'});
  }

  destroyed() {
    this.ws.close();
  }

  toggleDrawer() {
    this.drawer = !this.drawer;
  }

  onTab(item) {
    this.drawer = false;
    if (!item.subMenu) {
      this.links.map((link) => {
        if (link.openTab) {
          link.openTab = false;
        }
      });
    }
  }

  mounted() {
  }
};
